var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.3333,
    height: 37.3333,
    rx: 18.6667,
    fill: "#E8E8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 18.1298C28.0115 17.92 28.0115 17.7096 27.9999 17.4998C28.0016 15.9574 27.4939 14.4577 26.5555 13.2335C25.6172 12.0094 24.3009 11.1294 22.811 10.7304C21.3212 10.3313 19.7412 10.4355 18.3167 11.0267C16.8921 11.6179 15.7027 12.6631 14.9332 13.9998C14.1334 14.0425 13.358 14.2902 12.6817 14.7193C12.0054 15.1484 11.4509 15.7444 11.0715 16.4498C9.79244 16.6535 8.63455 17.3249 7.82234 18.3339C7.01013 19.3428 6.60146 20.6173 6.67556 21.9104C6.74966 23.2035 7.30125 24.423 8.22339 25.3326C9.14553 26.2421 10.3725 26.7769 11.6665 26.8331V26.8331H25.6665C26.6923 26.8313 27.6889 26.4916 28.5022 25.8665C29.3155 25.2414 29.9001 24.3657 30.1658 23.3749C30.4314 22.3841 30.3632 21.3334 29.9717 20.3853C29.5802 19.4372 28.8872 18.6445 27.9999 18.1298Z",
    fill: "#3535F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.64906bd611718e5ae4e9bec98a92f9a2.svg";
export { ForwardRef as ReactComponent };